<div class="row animated fadeInRight" *ngIf="mostrarFormulario">
    <div class="col-sm-12">
        <div class="card">
            <div class="card-header">
                <strong>Rol por usuario</strong>
            </div>
            <div class="card-body">
                <form [formGroup]="formulario" novalidate class="form-group">
                    <div class="row">
                        <div class="form-group col-md-6">
                            <app-lfsa-combo-box [opcion]="'descripcion'" [habilitar]="cmbDisabled" [idOpcion]="'id'" [comboBox]="cmbListRol" formControlName="rolId" [control]="formulario.get('rolId')" [label]="'Rol'" [id]="'idRol'"></app-lfsa-combo-box>
                        </div>
                        <div class="form-group col-md-6">
                            <app-lfsa-combo-box [opcion]="'nombre'" [habilitar]="cmbDisabled" [idOpcion]="'id'" [comboBox]="cmbListUsuario" formControlName="usuarioId" [control]="formulario.get('usuarioId')" [label]="'Usuario'" [id]="'idUsuario'"></app-lfsa-combo-box>
                        </div>
                    </div>
                    <app-lfsa-botones-formulario [formularioValido]="formulario.invalid" (devolverAccion)="acciones ( $event )" [textBoton]="textBoton"></app-lfsa-botones-formulario>
                </form>
            </div>
        </div>
    </div>
</div>
<div class="row col-md-12 animated fadeInRight" *ngIf="!mostrarFormulario">
    <h2 class="container float-left">Lista de roles por usuarios</h2>
    <hr/>
    <div class="container">
        <div class="row">
            <div class="col-md-9">
                <input class="form-control float-left " placeholder="Buscar.. " [(ngModel)]="textoBuscar " id="quickFilter " (keyup)="onQuickFilterChanged() " #quickFilter/>
            </div>
            <div class="col-md-3">
                <button (click)="nuevo()" class={{DAT_BTNCSS.success}}>{{DAT_BTNS.agregar}}</button>
            </div>
        </div>
    </div>
    <ag-grid-angular class="{{diccionarioModulo.agGrid.class}}" #agGrid [floatingFilter]="true"
                        [ngStyle]="diccionarioModulo.agGrid.style" id="{{diccionarioModulo.agGrid.id}}"
                        [paginationPageSize]="$any(diccionarioModulo.agGrid).paginacion" [pagination]="true"
                        [frameworkComponents]="frameworkComponents" [columnDefs]="columnDefs"
                        [rowSelection]="rowSelection" [rowData]="rowData" (gridReady)="onGridReady($event)">
    </ag-grid-angular>
</div>

